import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Document: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m420 390h-150v-30h120c16.57 0 30 13.43 30 30z' />
    <path d='m450 480h-180v-30h150c16.57 0 30 13.43 30 30z' />
    <path d='m600 660.16h-240l-180-.17v-539.83h255v30h-225v479.85l150.01.15h209.99v-345h30z' />
    <path d='m585 300.16h-150c-8.28 0-15-6.72-15-15v-150c0-6.07 3.65-11.54 9.26-13.86 5.6-2.32 12.06-1.04 16.35 3.25l150 150c4.29 4.29 5.57 10.74 3.25 16.35s-7.79 9.26-13.86 9.26zm-135-30h98.79l-98.79-98.79z' />
  </IconBase>
));

Document.displayName = 'Document';

export default Document;
